type LatLon = number | null;

export interface Location {
	id: string;
	// address: string;
	streetName: string;
	houseNumber: string;
	houseLetter: string;
	postalCode: string;
	postalArea: string;
	// municipality: string;
	// municipalityCode: string;
	// county: string;
	// region: string;
	// country: string;
	latitude: LatLon;
	longitude: LatLon;
	// tradeArea: unknown;
	// tradeAreaId: unknown;
	// addressText: unknown;
	// addressExtension: unknown;
	// officialCitySector: unknown;
	// citySector: unknown;
}

export interface ContactPoint {
	isMain: boolean;
	smsDisabled: boolean;
	findability: boolean;
	deleted: boolean;
	updated: boolean;
	deletable: boolean;
	name: string;
	type: string;
	source: string;
	sourceName: string;
	reservations: string;
	id: string;
	label: string;
	value: string;
	originalValue: string;
	sequenceNumber: unknown;
}

export interface Industry {
	id: string;
	code: string;
	isMain: boolean;
	name: string;
	deleted: boolean;
}

export interface PostBox {
	postalArea: string;
	postalCode: string;
	number: string;
	postOffice: string;
	country: unknown;
}

export interface OpeningHours {
	days: OpeningHoursDay[];
	showOpeningHours: boolean;
}

export interface OpeningHoursDay {
	name: string;
	opens: string;
	closes: string;
}

export interface Company {
	unitId: string;
	id: string;
	name: string;
	legalName: string;
	companyCode: string;
	location: Location;
	mainContactPointId: string;
	mainIndustryCode: string;
	contactPoints: ContactPoint[];
	emails: ContactPoint[];
	urls: ContactPoint[];
	phoneNumbers: ContactPoint[];
	socialMediaUrls: ContactPoint[];
	deletable: boolean;
	industries: Industry[];
	postBox: PostBox;
	localMainOffice: boolean;
	mainOffice: boolean;
	legalInformationRaw: string;
	searchterms: string[];
	savable: boolean;
	isHybrid: boolean;
	isConsentGiven: boolean;
	isManualGroup: boolean;
	isMemberOfManualGroup: boolean;
	openingHoursText: string;
	hasCapabilityMainNumber: boolean;
	hasProducts: boolean;
	manualVerificationStatus: ManualVerificationStatus;
	openingHours: OpeningHours;
}

export enum ManualVerificationStatus {
	None = 0,
	Pending = 1,
	Approved = 2,
	Denied = 3
  }

export interface ResponseStatus {
	errorCode?: string;
	message?: string;
	stackTrace?: unknown;
	errors?: unknown[];
}

export interface CompanyResponse {
	company?: Company;
	responseStatus?: ResponseStatus;
}

export interface UpdateCompanyResponse {
	company?: Company;
	success: boolean;
}

export interface CompanyOrgResponse {
	companies?: Company[];
	responseStatus?: ResponseStatus;
}

export interface AutoCompleteResponse {
	hits:AutoCompleteHit[];

}

export interface AutoCompleteHit {
	id: string;
	name: string;
	street: string;
	postalCode: string;
	postalArea: string;
}


export interface ActiveProductsResponse {
    activeProducts: Activeproduct[];
}

export interface Activeproduct {
    productName: string;
    startDate: Date;
    endDate: Date;
    count: number;
    industry: string;
    territory: string;
    betalingsStatus: string;
    leveringsStatus: string;
}

